import { useCallback, useEffect, useState } from 'react';
import { api } from '../../api/client';

const EVENEMENT = 'messages-maj';

/** À appeler après avoir marqué un message : le compteur du menu se met à jour tout de suite, sans attendre la minute suivante. */
export function annoncerMiseAJourMessages(): void {
  window.dispatchEvent(new Event(EVENEMENT));
}

/** Nombre de lignes de « Messages à envoyer » (pastille du menu, gestion). Null tant que rien n'est chargé. */
export function useCompteMessages(actif: boolean, page: string): number | null {
  const [compte, setCompte] = useState<number | null>(null);
  const charger = useCallback(() => {
    api.getCompteMessages().then((r) => setCompte(r.a_envoyer)).catch(() => { /* la pastille est un confort : on garde la dernière valeur */ });
  }, []);
  useEffect(() => {
    if (!actif) { setCompte(null); return; }
    charger();
    const minuteur = setInterval(charger, 60_000);
    window.addEventListener(EVENEMENT, charger);
    return () => { clearInterval(minuteur); window.removeEventListener(EVENEMENT, charger); };
  }, [actif, page, charger]);
  return compte;
}
